import { inWindow } from '@/config';
import { locationHelper } from '@/api/util/location_helper';
export var IFrameIdMap;
(function (IFrameIdMap) {
    IFrameIdMap["contactSyncIframe"] = "accountBgEntry";
    IFrameIdMap["contactEdmSyncIframe"] = "accountBgEntry";
})(IFrameIdMap || (IFrameIdMap = {}));
export const parentWindowIframeTarget = ':parent';
export const allAvailableNotificationType = ['mail', 'im'];
const DynamicEventType = process.env.BUILD_ISELECTRON ? 'electronMsg' : 'innerMsg';
export const systemEventAllType = {
    dbOperation: {
        eventKey: 'dbOperation',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '数据库操作',
        emitter: [],
        receiver: [],
        eventType: 'workerMsg',
        handlerWorkScript: '/worker/db.bundle.min.js',
        enable: false,
    },
    dbOperationRet: {
        eventKey: 'dbOperationRet',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '数据库操作返回',
        emitter: [],
        receiver: [],
        eventType: 'workerMsg',
        enable: false,
    },
    error: {
        eventKey: 'error',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '错误信息',
        emitter: [],
        receiver: [],
        toAllAccount: false,
        eventType: 'innerMsg',
        enable: true,
    },
    autoLogin: {
        eventKey: 'autoLogin',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录/登出事件',
        emitter: 'login_impl',
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 0,
        ttl: 30000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 102400,
        recordSample: 0,
    },
    login: {
        eventKey: 'login',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录/登出事件',
        emitter: 'login_impl',
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 0,
        ttl: 30000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 102400,
        recordSample: 0,
    },
    edmLogoutDeviceMsg: {
        eventKey: 'edmLogoutDeviceMsg',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '外贸通设备超限',
        emitter: 'login_impl',
        receiver: [],
        eventType: DynamicEventType,
        enable: true,
        persistTTL: 0,
        ttl: 30000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 102400,
        recordSample: 0,
    },
    edmLogoutDevice: {
        eventKey: 'edmLogoutDevice',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '外贸通设备超限',
        emitter: 'login_impl',
        receiver: [],
        eventType: DynamicEventType,
        enable: true,
        persistTTL: 0,
        ttl: 30000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 102400,
        recordSample: 0,
    },
    subAccountLogin: {
        eventKey: 'subAccountLogin',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录/登出事件',
        emitter: 'login_impl',
        receiver: [],
        eventType: DynamicEventType,
        enable: true,
        persistTTL: 0,
        ttl: 30000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 102400,
        recordSample: 0,
    },
    logout: {
        eventKey: 'logout',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '主动触发登出事件',
        emitter: '',
        receiver: ['login_impl'],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 10240,
        recordSample: 0,
    },
    subAccountLogout: {
        eventKey: 'subAccountLogout',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '主动触发登出事件',
        emitter: '',
        receiver: ['login_impl'],
        eventType: DynamicEventType,
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        recordLen: 10240,
        recordSample: 0,
    },
    preLogin: {
        eventKey: 'preLogin',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '预登录事件',
        emitter: 'login_impl',
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
    },
    loginExpired: {
        eventKey: 'loginExpired',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录失效事件',
        emitter: ['http_impl', 'contact_impl'],
        receiver: ['login_impl'],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        recordLen: 10240,
        recordSample: 0,
    },
    subAccountLoginHttpExpired: {
        eventKey: 'subAccountLoginHttpExpired',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录失效事件',
        emitter: ['http_impl', 'contact_impl'],
        receiver: ['login_impl'],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        recordLen: 10240,
        recordSample: 0,
    },
    loginRetry: {
        eventKey: 'loginRetry',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录重试',
        emitter: ['http_impl'],
        receiver: ['login_impl'],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        recordLen: 10240,
        recordSample: 0,
    },
    networkFail: {
        eventKey: 'networkFail',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '网络失效事件',
        emitter: ['http_impl'],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        recordLen: 1024,
        recordSample: 0.9,
    },
    keyboard: {
        eventKey: 'keyboard',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '窗口键盘事件触发',
        emitter: ['keyboard_impl'],
        receiver: ['web'],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 0,
        persist: 'memory',
        recordSample: 0.8,
    },
    initModule: {
        eventKey: 'initModule',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '各个模块初始化完成',
        emitter: ['api'],
        receiver: ['web'],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 60 * 1000,
        maxPersistNum: 10,
        persist: 'memory',
        recordSample: 0,
    },
    launchSuccessed: {
        eventKey: 'launchSuccessed',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '进度条完成加载',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
    },
    syncSchedule: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '日程主界面同步',
        eventKey: 'syncSchedule',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    syncScheduleState: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '跨窗口同步日历模块redux状态，跨窗口同步日历模块数据',
        eventKey: 'syncScheduleState',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    accountNotify: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '账号信息同步',
        eventKey: 'accountNotify',
        emitter: ['account_impl'],
        receiver: ['setting'],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 2000,
        persist: 'memory',
        recordSample: 0,
    },
    contactNotify: {
        eventKey: 'contactNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通讯更改通知',
        emitter: ['contact_impl'],
        receiver: [],
        eventType: 'electronMsg',
        eventTypes: ['electronMsg', 'innerMsg', 'iframeMsg'],
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    contactPersonalMarkNotify: {
        eventKey: 'contactPersonalMarkNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '个人/分组星标更改通知',
        emitter: ['contact_impl'],
        receiver: [],
        eventType: 'electronMsg',
        eventTypes: ['electronMsg', 'innerMsg', 'iframeMsg'],
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    contactEdmNotify: {
        eventKey: 'contactEdmNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '客户通讯更改通知',
        emitter: ['contact_edm_helper'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow()) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactEdmSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    colleagueEdmNotify: {
        eventKey: 'colleagueEdmNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '客户下属通讯更改通知',
        emitter: ['contact_edm_helper'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow()) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactEdmSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    contactAccountNotify: {
        eventKey: 'contactAccountNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通讯账户更改通知',
        emitter: ['contact_impl'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow()) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactEdmSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    contactCurrentAccountNotify: {
        eventKey: 'contactCurrentAccountNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'xxxx',
        emitter: ['contact_impl'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow()) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactEdmSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    contactOrgNotify: {
        eventKey: 'contactOrgNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通讯群组更改通知',
        emitter: ['contact_impl'],
        receiver: [],
        eventType: 'electronMsg',
        eventTypes: ['electronMsg', 'innerMsg', 'iframeMsg'],
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
        iframeElementId: () => {
            if (!inWindow()) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactEdmSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    recentContactNotify: {
        eventKey: 'recentContactNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '最近联系人通讯更改通知',
        emitter: ['contact_impl'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
    },
    customerMapChangeNotify: {
        eventKey: 'customerMapChangeNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '客户详情更改通知',
        emitter: ['contactReducer_customerMap'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        maxPersistNum: 1,
        recordSample: 0,
    },
    mailAliasAccountListChange: {
        eventKey: 'mailAliasAccountListChange',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '写信发件人配置更改通知',
        emitter: ['account_impl'],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
        persist: 'memory',
        persistTTL: 30000,
        recordSample: 0,
    },
    selectContactNotify: {
        eventKey: 'selectContactNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通讯录查询通知',
        emitter: ['contact_impl'],
        receiver: ['contactReducer'],
        eventType: 'innerMsg',
        enable: true,
        asInnerMsg: true,
        persist: 'memory',
        recordSample: 0.3,
        recordLen: 20480,
        persistTTL: 5000,
    },
    selectOrgNotify: {
        eventKey: 'selectOrgNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通讯录组织查询通知',
        emitter: ['contact_impl'],
        receiver: ['contactReducer'],
        eventType: 'innerMsg',
        enable: true,
        asInnerMsg: true,
        persist: 'memory',
        recordSample: 0.3,
        recordLen: 20480,
        persistTTL: 5000,
    },
    catalogNotify: {
        eventKey: 'catalogNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '日历更新通知',
        emitter: ['catalog_impl'],
        receiver: ['catalog'],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 0,
        persist: 'memory',
    },
    fsDownloadNotify: {
        eventKey: 'fsDownloadNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '文件下载进度更新通知',
        emitter: ['file_impl'],
        receiver: ['downloadCard'],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 0,
        recordSample: 0.8,
        persist: 'memory',
    },
    writeLatter: {
        eventKey: 'writeLatter',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '触发写信弹窗事件',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        toAllAccount: true,
        recordSample: 0,
    },
    attachToCloud: {
        eventKey: 'attachToCloud',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '附件转为云附件',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        toAllAccount: true,
        recordSample: 0,
    },
    electronClose: {
        eventKey: 'electronClose',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端窗口即将关闭',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    electronActive: {
        eventKey: 'electronActive',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端窗口获得焦点',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
    },
    electronBlur: {
        eventKey: 'electronBlur',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端窗口失去焦点',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
    },
    electronClosed: {
        eventKey: 'electronClosed',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端窗口关闭',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    electronIpcRet: {
        eventKey: 'electronIpcRet',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '其他窗口接受到消息后回复',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    electronShow: {
        eventKey: 'electronShow',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端窗口展示',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    electronHide: {
        eventKey: 'electronHide',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端窗口隐藏',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    notificationChange: {
        eventKey: 'notificationChange',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通知角标变化，会导致一级导航的角标出现更新',
        emitter: [''],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        enableInWeb: true,
        asInnerMsg: true,
        toType: ['main'],
        persist: 'memory',
        persistTTL: 5000,
        recordSample: 0.3,
    },
    updateUserInfo: {
        eventKey: 'updateUserInfo',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通知用户信息出现变化，需要更新展示当前用户数据的组件',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        recordSample: 0,
    },
    mailMsgCenter: {
        eventKey: 'mailMsgCenter',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件列表消息中心',
        emitter: [''],
        receiver: ['mailBox.tsx'],
        eventType: 'innerMsg',
        enable: true,
        recordSample: 0,
        asInnerMsg: true,
    },
    mailStoreRefresh: {
        eventKey: 'mailStoreRefresh',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '刷新邮件列表',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        asInnerMsg: true,
        enableInWeb: true,
        toAllAccount: true,
        toType: ['main', 'mail', 'readMail', 'readMailComb', 'strangerMails'],
        enable: true,
        recordSample: 0,
    },
    mailChanged: {
        eventKey: 'mailChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通知邮件数据出现变化，需要更新邮件列表',
        emitter: [''],
        receiver: ['mailBox.tsx'],
        eventType: 'electronMsg',
        enable: true,
        enableInWeb: true,
        asInnerMsg: true,
        toType: ['main', 'writeMail', 'readMailComb', 'readMail', 'strangerMails', 'mail'],
        recordSample: 0,
    },
    mailPushNotify: {
        eventKey: 'mailPushNotify',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件推送消息',
        emitter: [''],
        receiver: ['mailBox.tsx'],
        eventType: 'electronMsg',
        enable: true,
        enableInWeb: true,
        asInnerMsg: true,
        toType: ['main'],
        recordSample: 0,
    },
    upgradeApp: {
        eventKey: 'upgradeApp',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '展示升级app弹窗',
        emitter: [''],
        receiver: ['index.ts'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    bkStableSwitchAccount: {
        eventKey: 'bkStableSwitchAccount',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '后台页面切换账号是否成功',
        emitter: ['bkStable'],
        receiver: ['loginReducer'],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 5000,
        maxPersistNum: 1,
        enable: true,
        toAllAccount: true,
        toAllWin: true,
    },
    initPage: {
        eventKey: 'initPage',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '初始化页面数据',
        emitter: ['mainLayout.tsx'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        recordSample: 0,
        recordLen: 10240,
    },
    initBkLoginPage: {
        eventKey: 'initPage',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '初始化页面数据',
        emitter: ['mainLayout.tsx'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        toAllAccount: true,
        toAllWin: true,
        persistTTL: 3000,
        maxPersistNum: 1,
    },
    mainWindowNavigate: {
        eventKey: 'mainWindowNavigate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '主窗口navigate',
        emitter: ['mainLayout.tsx'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        toAllAccount: true,
        toAllWin: false,
        toType: ['main'],
        persistTTL: 3000,
        asInnerMsg: false,
        maxPersistNum: 1,
    },
    attachmentPreviewInitData: {
        eventKey: 'attachmentPreviewInitData',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '初始化attachmentPreview页面数据',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
        persistTTL: 5000,
    },
    electronTest: {
        eventKey: 'electronTest',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '测试electron消息收发',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
    },
    accountAdded: {
        eventKey: 'accountAdded',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '账号操作',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    settingShow: {
        eventKey: 'settingShow',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '设置界面显示隐藏切换',
        emitter: [''],
        receiver: ['avatar.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    messageDoubleClick: {
        eventKey: 'messageDoubleClick',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '消息tab双击',
        emitter: [''],
        receiver: ['imSessionList.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    mailSwitch: {
        eventKey: 'mailSwitch',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件切换状态',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    mailRealListTotalChanged: {
        eventKey: 'mailRealListTotalChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件列表总数变化',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    hiddenActiveIcon: {
        eventKey: 'hiddenActiveIcon',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '隐藏toolbar上的active图标',
        emitter: [''],
        receiver: ['sideBar.tsx'],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
    },
    writePageDataExchange: {
        eventKey: 'writePageDataExchange',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '写信页面与主页面交互',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        persistTTL: 30000,
        enable: true,
        asInnerMsg: true,
        recordSample: 0,
        enableInWeb: true,
        toAllAccount: true,
    },
    preCreateWriteTab: {
        eventKey: 'preCreateWriteTab',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '预创建写信标签',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        persistTTL: 30000,
        enable: true,
        asInnerMsg: true,
        recordSample: 0,
        enableInWeb: true,
    },
    destoryWriteTab: {
        eventKey: 'destoryWriteTab',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '销毁写信标签',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        persistTTL: 30000,
        enable: true,
        asInnerMsg: true,
        recordSample: 0,
        enableInWeb: true,
    },
    refreshLocalDraft: {
        eventKey: 'refreshLocalDraft',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '刷新本地草稿',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        persistTTL: 30000,
        enable: true,
        asInnerMsg: true,
        recordSample: 0,
        enableInWeb: true,
    },
    sendingMail: {
        eventKey: 'sendingMail',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件发信中',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        persistTTL: 30000,
        enable: true,
        asInnerMsg: true,
        recordSample: 0,
        enableInWeb: false,
    },
    loginBlock: {
        eventKey: 'loginBlock',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录封锁必要操作',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    chooseMailTag: {
        eventKey: 'chooseMailTag',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '选择邮件标签',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    mailTagChanged: {
        eventKey: 'mailTagChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件标签设置',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        recordSample: 0,
    },
    mailTranslateChanged: {
        eventKey: 'mailTranslateChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '一键翻译设置',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    mailStatesChanged: {
        eventKey: 'mailStatesChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件-红旗邮件设置',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        asInnerMsg: true,
        enableInWeb: true,
        recordSample: 0,
    },
    openWritePageFromMain: {
        eventKey: 'openWritePageFromMain',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '从非主窗口打开写信页面',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        toAllAccount: true,
        toType: ['main'],
    },
    deleteMailById: {
        eventKey: 'deleteMailById',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通知主窗口删除邮件',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        persist: 'memory',
    },
    iframeTest: {
        eventKey: 'iframeTest',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'iframe测试消息',
        emitter: [],
        receiver: [''],
        eventType: 'iframeMsg',
        enable: true,
        persist: 'memory',
        iframeElementId: () => {
            if (!inWindow()) {
                return 'no-key';
            }
            if (locationHelper.isMainPage()) {
                return IFrameIdMap.contactEdmSyncIframe;
            }
            return parentWindowIframeTarget;
        },
    },
    loginCrossWindow: {
        eventKey: 'loginCrossWindow',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '跨窗口发送登录信息',
        emitter: ['login'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        toAllWin: true,
        persistTTL: 5000,
        enable: true,
    },
    subAccountLoginExpiredCrossWindow: {
        eventKey: 'subAccountLoginExpiredCrossWindow',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '跨窗口发送登录过期信息',
        emitter: ['login'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 1000,
        ttl: 10000,
        enable: true,
        toAllWin: true,
        recordSample: 0,
        toAllAccount: true,
    },
    loginExpiredCrossWindow: {
        eventKey: 'loginExpiredCrossWindow',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '跨窗口发送登录过期信息',
        emitter: ['login'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 1000,
        ttl: 10000,
        enable: true,
        toAllWin: true,
        recordSample: 0,
    },
    toSaveDraft: {
        eventKey: 'toSaveDraft',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '保存草稿',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
    },
    toAddAccount: {
        eventKey: 'toAddAccount',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加邮箱账号',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
    },
    toSendMail: {
        eventKey: 'toSendMail',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '发信',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
    },
    diskInnerCtc: {
        eventKey: 'diskInnerCtc',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '网盘内部通讯',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    emailListChange: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '本地陌生人列表变化',
        eventKey: 'emailListChange',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        toAllWin: true,
        asInnerMsg: true,
        enableInWeb: true,
        toType: ['main', 'writeMail', 'readMailComb', 'readMail', 'strangerMails', 'mail'],
    },
    setPriorities: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '设置优先级',
        eventKey: 'setPriorities',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        toType: ['main', 'writeMail', 'readMailComb', 'readMail', 'strangerMails', 'mail'],
        asInnerMsg: true,
        enableInWeb: true,
        recordSample: 0,
    },
    noLoginStatus: {
        eventKey: 'noLoginStatus',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '正常退出登录状态且停留在界面内',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    sharedAccountLogout: {
        eventKey: 'sharedAccountLogout',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '正常退出登录状态且停留在界面内',
        emitter: ['http_impl'],
        receiver: ['account_impl'],
        eventType: 'innerMsg',
        enable: true,
    },
    routeChange: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通知主窗口，路由变化',
        eventKey: 'routeChange',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 5000,
        toAllWin: true,
        asInnerMsg: true,
        enable: true,
        recordSample: 0,
        enableInWeb: true,
    },
    tabsDrop: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '多页签夸窗口拖拽',
        eventKey: 'tabsDrop',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 5000,
        toType: ['main', 'disk', 'resources'],
        asInnerMsg: false,
        enable: true,
    },
    tabsOperation: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '通知主窗口，操作页签',
        eventKey: 'tabsOperation',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 5000,
        toType: ['main'],
        asInnerMsg: false,
        enable: true,
    },
    diskNps: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '云文档NPS通知',
        eventKey: 'diskNps',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    mailOperation: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件操作信息同步',
        eventKey: 'mailOperation',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        toType: ['main', 'writeMail', 'readMailComb', 'readMail', 'strangerMails', 'mail', 'bkStable'],
        asInnerMsg: true,
        recordSample: 0,
    },
    shouldUpdateAppChanged: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '展示升级版本图标',
        eventKey: 'shouldUpdateAppChanged',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    acrossWinBridge: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '跨窗口数据传送',
        eventKey: 'acrossWinBridge',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        asInnerMsg: false,
        recordSample: 0.95,
        recordLen: 3072,
    },
    imTeamEvents: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'IM群组变更推送',
        eventKey: 'imTeamEvents',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        asInnerMsg: false,
        enableInWeb: true,
    },
    mailOperationWeb: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件操作信息同步（Web）',
        eventKey: 'mailOperationWeb',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    todoChange: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '任务详情信息同步',
        eventKey: 'todoChange',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
        toAllWin: true,
        asInnerMsg: true,
        enableInWeb: true,
    },
    mailMenuOper: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '邮件菜单弹窗逻辑的调用（移动|举报|打印等',
        eventKey: 'mailMenuOper',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 5000,
        maxPersistNum: 1,
        enable: true,
    },
    storeChangeEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '',
        eventKey: 'data_store_impl.ts',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 5000,
        maxPersistNum: 10,
        enable: true,
    },
    storeUserChangeEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '',
        eventKey: 'storeUserChangeEvent',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 5000,
        maxPersistNum: 10,
        enable: true,
    },
    initAddAccountPageEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '初始化添加账号页面数据初始化事件',
        eventKey: 'initAddAccountPageEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        maxPersistNum: 1,
        toAllAccount: true,
        persistTTL: 1000,
    },
    addAccountPageReturnEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'addAccountPageReturnEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        maxPersistNum: 1,
        toAllAccount: true,
        persistTTL: 1000,
    },
    edmGlobalNotice: {
        eventKey: 'edmGlobalNotice',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '全局通知',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    whatsAppContactsUpdate: {
        eventKey: 'whatsAppContactsUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp 联系人更新',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    whatsAppMessagesUpdate: {
        eventKey: 'whatsAppMessagesUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp 消息更新',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    whatsAppMessageStatus: {
        eventKey: 'WhatsAppMessageStatus',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp 消息状态变更',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    whatsAppMessagesUpdateV2: {
        eventKey: 'whatsAppMessagesUpdateV2',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp 消息更新',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    whatsAppFileShareEvent: {
        eventKey: 'whatsAppFileShareEvent',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp 新建分享文件',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    whatsAppMessageStatusV2: {
        eventKey: 'WhatsAppMessageStatusV2',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp 消息状态变更',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    whatsAppProxyWarning: {
        eventKey: 'whatsAppProxyWarning',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'whatsApp IP 异常',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    facebookNewMessage: {
        eventKey: 'facebookNewMessage',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'facebook 新消息',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    facebookAccountExpires: {
        eventKey: 'facebookAccountExpires',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'facebook 账号失效',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    socialMediaNewMsg: {
        eventKey: 'socialMediaNewMsg',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '社媒新消息',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    initBindSubAccountPageEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'initBindSubAccountPageEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    subAccountPageReturnEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'subAccountPageReturnEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    initSubAccountBgPageEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'initSubAccountBgPageEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    addSubAccountPageReturnEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'addSubAccountPageReturnEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    addSubAccountPageSendMobileCode: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'addSubAccountPageSendMobileCode',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    addSubAccountPageSendMobileCodeReturnEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'addSubAccountPageSendMobileCodeReturnEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    addSubAccountPageVerifyMobileCode: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'addSubAccountPageVerifyMobileCode',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    addSubAccountPageVerifyMobileCodeReturnEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'addSubAccountPageVerifyMobileCodeReturnEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    initAddSubAccountPageEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'initAddSubAccountPageEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    initAddPersonalSubAccountPageEvent: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'initAddPersonalSubAccountPageEvent',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllAccount: true,
        persistTTL: 1000,
    },
    SubAccountDeleted: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '子账号删除事件',
        eventKey: 'SubAccountDeleted',
        emitter: [''],
        receiver: [''],
        eventType: DynamicEventType,
        enable: true,
        toAllAccount: true,
        toAllWin: true,
        persistTTL: 5000,
        asInnerMsg: true,
    },
    SubAccountAdded: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '子账号添加成功事件',
        eventKey: 'SubAccountAdded',
        emitter: [''],
        receiver: [''],
        eventType: DynamicEventType,
        enable: true,
        toAllAccount: true,
        toAllWin: true,
        persistTTL: 5000,
        asInnerMsg: true,
    },
    SubAccountWindowReady: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '子账号窗口ready',
        eventKey: 'SubAccountWindowReady',
        emitter: [''],
        receiver: [''],
        eventType: DynamicEventType,
        enable: true,
        toAllAccount: true,
        toAllWin: true,
        persistTTL: 3000,
        asInnerMsg: true,
    },
    SubAccountWindowClosed: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '子账号窗口关闭',
        eventKey: 'SubAccountWindowClosed',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toAllWin: true,
        toAllAccount: true,
        persistTTL: 3000,
        asInnerMsg: true,
    },
    SubAccountLoginExpired: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'SubAccountLoginExpired',
        emitter: [''],
        receiver: [''],
        eventType: DynamicEventType,
        enable: true,
        toAllAccount: true,
        toAllWin: true,
        persistTTL: 3000,
        asInnerMsg: true,
    },
    SubAccountLoginPreExpired: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '添加账号页面数据返回事件',
        eventKey: 'SubAccountLoginPreExpired',
        emitter: [''],
        receiver: [''],
        eventType: DynamicEventType,
        enable: true,
        toAllAccount: true,
        toAllWin: true,
        persistTTL: 3000,
        asInnerMsg: true,
    },
    subAccountDBChanged: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '子账号DB信息变更事件',
        eventKey: 'subAccountDBChanged',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        toAllAccount: false,
        toAllWin: false,
        persistTTL: 3000,
    },
    regularCustomerMenuUpdate: {
        eventKey: 'regularCustomerMenuUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'regularCustomerMenuUpdate',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    syncSubAccountUnreadCount: {
        eventKey: 'syncSubAccountUnreadCount',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'syncSubAccountUnreadCount',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        toType: ['main'],
        persistTTL: 5000,
        asInnerMsg: false,
    },
    globalSearchSubscribeUpdate: {
        eventKey: 'globalSearchSubscribeUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'globalSearchSubscribeUpdate',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    globalSearchCheckAllAiKeywords: {
        eventKey: 'globalSearchCheckAllAiKeywords',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'globalSearchCheckAllAiKeywords',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'none',
        enable: true,
    },
    wmDataDetailNavigate: {
        eventKey: 'wmDataDetailNavigate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '大数据详情页内跳转',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        toAllAccount: true,
        toAllWin: false,
        toType: ['main'],
        persistTTL: 3000,
        asInnerMsg: false,
        maxPersistNum: 1,
    },
    customDataStarUpdate: {
        eventKey: 'customDataStarUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'customDataStarUpdate',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    globalSearchGrubTaskAdd: {
        eventKey: 'globalSearchGrubTaskAdd',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'globalSearchGrubTaskAdd',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'none',
        enable: true,
    },
    globalSearchGrubTaskFinish: {
        eventKey: 'globalSearchGrubTaskFinish',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'globalSearchGrubTaskFinish',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'none',
        enable: true,
    },
    aiGlobalSearchDraw: {
        eventKey: 'aiGlobalSearchDraw',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'aiGlobalSearchDraw',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'none',
        enable: true,
    },
    openMarketingDetail: {
        eventKey: 'openMarketingDetail',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'openMarketingDetail',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
    },
    SystemTaskNewTask: {
        eventKey: 'SystemTaskNewTask',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '系统任务新任务',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    SystemTaskStatusUpdate: {
        eventKey: 'SystemTaskStatusUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '系统任务状态更新',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    TaskStatusUpdateV2: {
        eventKey: 'TaskStatusUpdateV2',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '任务状态更新',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    AiAssistantUnreadReddot: {
        eventKey: 'aiAssistantUnreadReddot',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'AI助理消息提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    MarketingExpertUnreadReddot: {
        eventKey: 'marketingExpertUnreadReddot',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '营销专家消息提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    BuildWebsiteExpertUnreadReddot: {
        eventKey: 'buildWebsiteExpertUnreadReddot',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '建站专家消息提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    OperationExpertUnreadReddot: {
        eventKey: 'operationExpertUnreadReddot',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '运营专家消息提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    SocialMediaExpertUnreadReddot: {
        eventKey: 'socialMediaExpertUnreadReddot',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '社媒专家消息提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    TotalUnreadReddot: {
        eventKey: 'totalUnreadReddot',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'AI团队总推送消息提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    NoviceTaskRemind: {
        eventKey: 'NoviceTaskRemind',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '新手任务提醒',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    NoviceTaskRegister: {
        eventKey: 'NoviceTaskRegister',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '注册新手任务到 redux',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    NoviceTaskFinished: {
        eventKey: 'NoviceTaskRegister',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '完成新手任务',
        emitter: [''],
        receiver: ['index.tsx'],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    changeCoreContactSyncStatus: {
        eventKey: 'changeCoreContactSyncStatus',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'changeCoreContactSyncStatus',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 1000,
        asInnerMsg: true,
        enableInWeb: true,
        persist: 'memory',
        toType: ['bkStable', 'main'],
    },
    coreOrgPathlistReady: {
        eventKey: 'coreOrgPathlistReady',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'coreOrgPathlistReady',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        persistTTL: 5000,
        asInnerMsg: true,
    },
    setDATrackerToken: {
        eventKey: 'setDATrackerToken',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'setDATrackerToken',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        persist: 'memory',
        persistTTL: 5000,
        asInnerMsg: false,
    },
    onAppLockChanged: {
        eventKey: 'onAppLockChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'onAppLockChanged',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        persistTTL: 1000,
        asInnerMsg: false,
    },
    subCoreOrgContactReady: {
        eventKey: 'coreOrgPathlistReady',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'coreOrgPathlistReady',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        persistTTL: 5000,
        asInnerMsg: true,
    },
    aiTimesUpdate: {
        eventKey: 'aiTimesUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'aiTimesUpdate',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    initSendAttachmentsWritePage: {
        eventKey: 'initSendAttachmentsWritePage',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'initSendAttachmentsWritePage',
        emitter: [''],
        receiver: [''],
        eventType: 'electronMsg',
        enable: true,
        persist: 'memory',
        persistTTL: 1000,
        asInnerMsg: false,
    },
    sendSelectedContactIdOnContactPage: {
        eventKey: 'sendSelectedContactIdOnContactPage',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '设置默认选中的通讯录ID',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
        persist: 'memory',
        persistTTL: 1000,
        asInnerMsg: false,
    },
    customNotification: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '桌面端全局消息通知',
        eventKey: 'customNotification',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 5000,
        toType: ['scheduleReminder', 'downloadReminder', 'advertisingReminder'],
        asInnerMsg: false,
        enable: true,
    },
    detectContactException: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '检测到通讯录数据异常',
        eventKey: 'detectContactException',
        emitter: [],
        receiver: [],
        toAllWin: true,
        eventType: 'electronMsg',
        persistTTL: 100,
        asInnerMsg: true,
        enable: true,
    },
    detectContactExceptionInWeb: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '检测到通讯录数据异常',
        eventKey: 'detectContactExceptionInWeb',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        persistTTL: 100,
        asInnerMsg: true,
        enable: true,
    },
    syncSubAccountState: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '同步子账号窗口的登录数据到主账号窗口',
        eventKey: 'syncSubAccountState',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persistTTL: 5000,
    },
    closeSchedulerReminder: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '关闭日历提醒消息通知',
        eventKey: 'closeSchedulerReminder',
        emitter: [],
        receiver: [],
        eventType: 'electronMsg',
        persist: 'memory',
        persistTTL: 5000,
        toType: ['main'],
        asInnerMsg: false,
        enable: true,
    },
    lockScreen: {
        eventKey: 'lockScreen',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '系统锁屏',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    unlockScreen: {
        eventKey: 'unlockScreen',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '系统解锁',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    willNavigate: {
        eventKey: 'willNavigate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '页面即将跳转',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 5000,
        toAllWin: false,
        toType: ['main', 'addAccount'],
        asInnerMsg: true,
        enable: true,
    },
    laptopSuspend: {
        eventKey: 'laptopSuspend',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '电脑休眠',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    laptopResume: {
        eventKey: 'laptopResume',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '电脑休眠恢复',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
        recordSample: 0,
    },
    upgradeVersion: {
        eventKey: 'upgradeVersion',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '升级版本',
        emitter: [],
        receiver: [''],
        eventType: 'electronMsg',
        persistTTL: 30000,
        enable: true,
        asInnerMsg: true,
        recordSample: 0,
        enableInWeb: true,
    },
    requireModuleGuide: {
        eventKey: 'requireModuleGuide',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '全局使用指引Modal',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        persist: 'memory',
        enable: true,
    },
    edmPrivilegeReady: {
        eventKey: 'edmPrivilegeReady',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'edmPrivilegeReady',
        emitter: ['edm_role_impl'],
        receiver: ['customerMailRelatedBox.tsx'],
        eventType: 'innerMsg',
        enable: true,
    },
    toMuchOrToSlowLogger: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '日志打点太频繁或者太慢',
        eventKey: 'toMuchOrToSlowLogger',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    changeQuickMarktingGroup: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '切换营销联系人快捷营销Tab',
        eventKey: 'changeQuickMarktingGroup',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    displayMarketingModal: {
        eventKey: 'displayMarketingModal',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '营销弹窗展示',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    whatsappSubscribeUpdate: {
        eventKey: 'whatsappSubscribeUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'WA一级菜单红点',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    anomalyMonitoringCountUpdate: {
        eventKey: 'anomalyMonitoringCountUpdate',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '领航版客户背调客户异动监测数',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    subAccountSyncLoginStart: {
        eventKey: 'subAccountSyncLoginStart',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '开始登录子账号',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    subAccountSyncLoginFailed: {
        eventKey: 'subAccountSyncLoginFailed',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '登录子账号结束',
        emitter: [''],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
    },
    syncEdmMailSideData: {
        eventKey: 'syncEdmMailSideData',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '外贸邮箱侧边栏数据同步',
        emitter: ['rightSidebar.tsx'],
        receiver: ['rightSidebar.tsx'],
        eventType: 'electronMsg',
        toType: ['readMail', 'main'],
        enable: true,
        persistTTL: 100,
        enableInWeb: false,
        asInnerMsg: false,
    },
    watermarkChanged: {
        eventKey: 'watermarkChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '水印更新',
        emitter: [''],
        receiver: [],
        eventType: 'electronMsg',
        enable: true,
        persist: 'memory',
        toAllAccount: true,
        asInnerMsg: true,
        enableInWeb: true,
        toAllWin: true,
    },
    mainWindowToggleMsg: {
        eventKey: 'mainWindowToggleMsg',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '主窗口 msg',
        emitter: ['mainLayout.tsx'],
        receiver: [''],
        eventType: 'electronMsg',
        persist: 'memory',
        enable: true,
        toAllAccount: true,
        toAllWin: false,
        toType: ['main'],
        persistTTL: 3000,
        asInnerMsg: false,
        maxPersistNum: 1,
    },
    sendMailFailJumpYingxiao: {
        eventKey: 'sendMailFailJumpYingxiao',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '发信失败跳转邮件营销',
        emitter: ['mail_abs_handler.ts'],
        receiver: ['reducerComponent.tsx'],
        eventType: 'electronMsg',
        toType: ['writeMail', 'main'],
        enable: true,
        enableInWeb: true,
        asInnerMsg: true,
    },
    wmReplyUnreadOver3Days: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '【潜在客户回复】文件夹存在超过三天未读邮件通知，需要跳转',
        eventKey: 'wmReplyUnreadOver3Days',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        enableInWeb: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    openTargetTabDetailDrawer: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '打开营销话术详情抽屉',
        eventKey: 'openTargetTabDetailDrawer',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    openAutoModalWithData: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '打开营销openAutoMarketingModal窗口',
        eventKey: 'openAutoModalWithData',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    reloadEffectStatCount: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '刷新营销效果统计未读数',
        eventKey: 'reloadEffectStatCount',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    assistantContextChanged: {
        eventKey: 'assistantContextChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'AI助手上下文变化',
        emitter: [''],
        receiver: [''],
        eventType: 'innerMsg',
        enable: true,
    },
    reloadPotentialTaskCount: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '刷新潜客营销任务全部潜在客户联系人数',
        eventKey: 'reloadPotentialTaskCount',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    toSaveAutoClassify: {
        eventKey: 'toSaveAutoClassify',
        eventName: '保存营销自动分类',
        emitter: [],
        receiver: [''],
        eventType: 'innerMsg',
        persist: 'memory',
        persistTTL: 0,
        enable: true,
    },
    npsShowStatusChange: {
        eventName: process.env.NODE_ENV !== 'development' ? '' : '展示NPS状态改变',
        eventKey: 'npsShowStatusChange',
        emitter: [],
        receiver: [],
        eventType: 'innerMsg',
        enable: true,
        persistTTL: 5000,
        persist: 'memory',
    },
    changeLxTrafficLabel: {
        eventKey: 'changeLxTrafficLabel',
        eventName: '',
        emitter: [],
        receiver: [],
        toAllAccount: false,
        eventType: 'innerMsg',
        enable: true,
    },
    themeChanged: {
        eventKey: 'themeChanged',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '外观主题变化',
        emitter: [],
        receiver: [],
        toAllAccount: false,
        eventType: 'innerMsg',
        enable: true,
    },
    miniapp: {
        eventKey: 'miniapp',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'miniapp机制事件',
        emitter: [],
        receiver: [],
        toAllAccount: false,
        eventType: 'innerMsg',
        enable: true,
    },
    AIAssistantEvent: {
        eventKey: 'AIAssistantEvent',
        eventName: process.env.NODE_ENV !== 'development' ? '' : 'AI助理发起事件',
        emitter: [],
        receiver: [],
        toAllAccount: false,
        eventType: 'innerMsg',
        enable: true,
    },
    RiskHitInterrupt: {
        eventKey: 'RiskHitInterrupt',
        eventName: process.env.NODE_ENV !== 'development' ? '' : '风控中断事件',
        emitter: [],
        receiver: [],
        toAllAccount: false,
        eventType: 'innerMsg',
        enable: true,
    },
};
